const API_BASE_URL = "https://api.icpcs.io"

async function createUser(principal, identity, settings) {
  try {
    const response = await fetch(`${API_BASE_URL}/users`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        principal: principal,
        identity: identity,
        settings: settings
      })
    });
    const result = await response.text();
    console.log(result);
  } catch (error) {
    console.error(error);
  }
}

async function updateUser(principal, identity, newSettings) {
  try {
    const response = await fetch(`${API_BASE_URL}/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        principal: principal,
        identity: identity,
        settings: newSettings
      })
    });
    const result = await response.text();
    console.log(result);
  } catch (error) {
    console.error(error);
  }
}

async function getPrincipalsByIdentity(identity) {
  try {
    const response = await fetch(`${API_BASE_URL}/users/principals?identity=${identity}`, {
      method: 'GET'
    });
    const result = await response.json();
    return result.principals; 
  } catch (error) {
    console.error(error);
  }
}

async function getUserSettings(principal, identity) {
  try {
    const response = await fetch(`${API_BASE_URL}/users/settings?principal=${principal}&identity=${identity}`, {
      method: 'GET'
    });
    const result = await response.json();
    if (result.error) {
      throw new Error(result.error);
    }
    return result.settings;
  } catch (error) {
    console.error(error);
  }
}

async function checkUserExists(principal, identity) {
  try {
    const response = await fetch(`${API_BASE_URL}/users/userExists?principal=${principal}&identity=${identity}`, {
      method: 'GET'
    });
    const result = await response.text();
    if (result == 'true') {
			return true;
		} else {
			return false;
		}
  } catch (error) {
    console.error(error);
  }
}

function generateSettingsObject(newSettings) {
  let settingsObject = {
    settings: []
  };
  // Append the new settings to the settings array
  settingsObject.settings = settingsObject.settings.concat(newSettings);

  return settingsObject;
}


export { createUser, updateUser, getUserSettings, checkUserExists, generateSettingsObject, getPrincipalsByIdentity }
